import vars from '../helpers';
import matrix from './matrix';
import scroller from './scroller';
import analytics from './analytics';
import {changeTextNavigation} from './chapterAnimation/navigation';
import {figureParallax} from './chapterAnimation/figureParallax';
import helpers from "../helpers";

let $scrollArray;

const $homeCanvas = vars.$document.find('.home__video');
const $homeMatrix = vars.$document.find('.home__matrix');
const $homeSocial = vars.$document.find('.home__social');
const $homeHonors = vars.$document.find('.home__honors');
const $homeArrow = vars.$document.find('.home__arrow');
const $homeText = vars.$document.find('.home__text');
const $black = vars.$html.find('.black');

let sumHeight = 0;
let articleHeights = [];
let articleTops = [];

const getScrollArray = () => {
	$scrollArray = vars.$siteContainer.find('.chapters');
};

const sortArticle = () => {
	$scrollArray.each((i, e) => {
		$(e).css({
			zIndex: `-=${i}`,
		});
	});
};

const shares = {
	'0': {
		id: 0,
		title: 'Цифровое будущее атомного машиностроения',
		description: 'О том, как идёт переход к цифровому будущему в атомном машиностроении'
	},

	'tsifrovizatsiya-proizvodstva': {
		id:1,
		title: 'Что такое цифровизация производства?',
		description: 'Фундамент цифровизации — аналитика данных, или процесс преобразования полученной информации в полезные знания, которые можно использовать в дальнейшем'
	},
	'elementy-tsifrovogo-zavoda': {
		id: 2,
		title: 'Элементы цифрового завода «аэм-технологии»',
		description: 'Цифровизация процессов имеет ключевое значение для машиностроительного дивизиона Росатома — Атомэнергомаша'
	},

	'promyshlennost-novogo-pokoleniya': {
		id: 3,
		title: 'Какой станет промышленность нового поколения?',
		description: 'Три основных параметра будут характеризовать промышленность будущего: цифровые двойники, цифровое производство и предиктивная аналитика'
	}
}

const changeShare = (url) => {
	let mainTitle = document.querySelector('title');

	let title = $('[name="twitter:title"], [property="og:title"]');
	let description = $('[name="twitter:description"], [name="description"], [property="og:description"]');
	title.attr('content', shares[url].title)
	mainTitle.textContent = shares[url].title;
	description.attr('content', shares[url].description)
};

const calcSumHeight = () => {
	sumHeight = 0;

	$scrollArray.each((i, e) => {
		let $this = $(e);

		articleTops[i] = sumHeight;
		articleHeights[i] = $this.outerHeight();

		sumHeight += $this.outerHeight();
	});

	scroller.setHeight(sumHeight);
};

const articleScroll = () => {
	let activeArticle = false;
	let canvasContainer = $homeCanvas.offset().top;
	let text = vars.$document.find('.home__text').offset().top;

	const scrollToActiveArticleOnLoad = () => {
		const str = window.location.pathname.replace('aemtech', '').split('/').join('');

		if (str) {
			vars.scrollToAnchor(articleTops[shares[str].id], 0, 1);
		}
	};

	const setLink = (id, url) => {
		const urlCurrent = location.href;

		vars.$html
			.data('chapters', id)
			.attr('data-chapters', id)
			.attr('data-link', url);

		if (id === 0) {
			matrix.play();

			vars.$document.trigger('video-play');

			changeTextNavigation(document.querySelector('[data-chapters="1"]'));
			figureParallax();

			history.pushState({}, '', `/aemtech/${location.search}${location.hash}`);
		} else {
			matrix.pause();

			vars.$document.trigger('video-pause');
			vars.$document.trigger('show-animation', [id]);

			history.pushState({}, '', `/aemtech/${url}${location.search}${location.hash}`);
		}
	};

	const scrollChapters = () => {
		const scrollTop = scroller.getPosition();

		$scrollArray.each((i, e) => {
			let $this = $(e);

			let thisArticle = parseInt($this.data('chapters'), 10);
			let thisLink = $this.data('link');
			let isEnded = false;
			let isReady = false;

			if (scrollTop <= articleTops[i]) {
				if (!isReady) {
					gsap.to($this, {
						duration: 0,
						y: 0,
						ease: 'Linear.easeNone',
					});

					isReady = true;
				}
			} else if (scrollTop >= articleTops[i] + articleHeights[i]) {
				if (!isEnded) {
					gsap.to($this, {
						duration: 0,
						y: -Math.floor(articleTops[i] + articleHeights[i]),
						ease: 'Linear.easeNone',
					});
					// if(helpers.$html.attr('data-chapters') === "2") {
					// 	console.log(articleHeights[1])
					// 	gsap.to($this, {
					// 		duration: 0,
					// 		y: -Math.floor(articleHeights[1]),
					// 		ease: 'Linear.easeNone',
					// 	});
					// } else {
					// 	gsap.to($this, {
					// 		duration: 0,
					// 		y: -Math.floor(articleTops[i] + articleHeights[i]),
					// 		ease: 'Linear.easeNone',
					// 	});
					// }

					isEnded = true;
				}
			} else {
				let opacity = (-Math.floor(articleTops[i + 1] - 1000 - scrollTop) * 0.001).toFixed(2);

				if (scrollTop > articleTops[i + 1] - 1000) {
					$black.css('opacity', -(opacity - 1));
				}

				if (scrollTop > articleTops[i + 1] - 250) {
					changeTextNavigation(document.querySelector(`.page[data-chapters="${thisArticle + 1}"]`));
				} else if (thisArticle) {
					changeTextNavigation(document.querySelector(`.page[data-chapters="${thisArticle}"]`));
				}

				gsap.to($this, {
					duration: 0,
					y: Math.floor(articleTops[i] - scrollTop),
					ease: 'Linear.easeNone',
				});

				isReady = false;
				isEnded = false;
			}

			if (scrollTop >= articleTops[i] && scrollTop < articleTops[i] + articleHeights[i]) {

				if (thisArticle !== activeArticle) {
					vars.$siteContainer.find('.chapters').removeClass('is-active');
					$this.addClass('is-active');

					setLink(thisArticle, thisLink);

					analytics.virtualHit();

					vars.$html.addClass('is-enter');

					changeShare(thisLink);

					activeArticle = thisArticle;
				}
			}
		});

		if (vars.$siteContainer.find('.chapters--0').hasClass('is-active')) {
			vars.$document.trigger('bg-play', '.home__bg');

			$homeMatrix.css('transform', `translateY(${scrollTop > canvasContainer ? scrollTop : 0}px`);

			if (!vars.isMobile()) {
				vars.$document.find('.header').toggleClass('is-hide', scrollTop > 50);

				$homeSocial.toggleClass('is-hide', scrollTop > canvasContainer + 50);
				$homeHonors.toggleClass('is-hide', scrollTop > canvasContainer + 50);
				$homeArrow.css('transform', `translateY(${scrollTop > 0 ? scrollTop : 0}px)`);

				if (scrollTop > articleHeights[0] / 2) {
					$homeArrow.css('transform', `translateY(${articleHeights[0] / 2}px`);
				}

				$homeCanvas.css('transform', `translateY(${scrollTop > canvasContainer ? scrollTop - canvasContainer : 0}px)`);

				if (scrollTop - canvasContainer > text + $homeText.outerHeight() / 8) {
					$homeCanvas.css('transform', `translateY(${text + $homeText.outerHeight() / 12}px)`);
				}
			} else {
				vars.$document.find('.header').toggleClass('is-hide', scrollTop > 5);
			}
		} else {
			vars.$document.trigger('bg-destroy', '.home__bg');
			vars.$document.find('.header').addClass('is-hide', scrollTop > 1);
		}

		vars.$document.find('.navigation__arrow').toggleClass('is-rotate', vars.$siteContainer.find('.chapters--3').hasClass('is-active'));
		vars.$document.find('.menu-link').removeClass('is-active');
		vars.$document.find(`.menu-link[data-chapter="${vars.$html.attr('data-chapters')}"]`).addClass('is-active');
	};

	scroller.getElement().addEventListener('scroll', scrollChapters);

	$homeArrow.on('click', () => {
		vars.scrollToAnchor(articleTops[1] + 50);
	});

	vars.$document.find('.navigation__arrow').on('click', () => {
		const $chapterActive = vars.$document.find('.chapters.is-active');
		const scrollNext = $chapterActive.next().attr('data-chapters');

		if ($chapterActive.attr('data-chapters') === 3) {
			vars.scrollToAnchor(0);
		} else {
			vars.scrollToAnchor(articleTops[scrollNext] + 50);
		}
	});

	vars.$document.find('.menu-link').on('click', (event) => {
		event.preventDefault();

		const $thisTarget = $(event.currentTarget);

		const chapterIndex = $thisTarget.attr('data-chapter');
		const additionalOffset = chapterIndex === '0' ? 0 : 50;

		vars.$document.trigger('menu-close');

		vars.scrollToAnchor(articleTops[chapterIndex] + additionalOffset, 0);
	});

	calcSumHeight();
	scrollToActiveArticleOnLoad();
	scrollChapters();
};

const resize = calcSumHeight;

const init = () => {
	getScrollArray();
	sortArticle();
	articleScroll();
};

export default {
	init,
	resize,
};
